import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import AuthState from "./context/auth/AuthState";
import PlatoState from "./context/platos/PlatoState";
import MenuState from "./context/menus/MenuState";
import Header from "./components/Header";
import Footer from "./components/Footer";
import IniciarSesion from "./pages/IniciarSesion";
import RegistrarUsuario from "./pages/RegistrarUsuario";
import OlvidoClave from "./pages/OlvidoClave";
import Platos from "./pages/Platos";
import Menus from "./pages/Menus";
import Dashboard from "./pages/Dashboard";
import Private from "./config/Private";
import "react-toastify/dist/ReactToastify.css";
import "moment/locale/es";

function App() {
  return (
    <AuthState>
      <PlatoState>
        <MenuState>
          <BrowserRouter>
            <Header />
            <Routes>
              <Route
                path="/"
                element={
                  <Private>
                    <Dashboard />
                  </Private>
                }
              />
              <Route path="/iniciar-sesion" element={<IniciarSesion />} />
              <Route path="/registrar-usuario" element={<RegistrarUsuario />} />
              <Route path="/olvido-clave" element={<OlvidoClave />} />
              <Route
                path="/platos"
                element={
                  <Private>
                    <Platos />
                  </Private>
                }
              />
              <Route
                path="/menus"
                element={
                  <Private>
                    <Menus />
                  </Private>
                }
              />
            </Routes>
            <Footer />
          </BrowserRouter>
          <ToastContainer />
        </MenuState>
      </PlatoState>
    </AuthState>
  );
}

export default App;
